// src/connection/perfMarks.ts — User Timing marks for the click-to-paint numbers of
// agent-chat-speed Decision 7. Read them in the browser or in Playwright with
// performance.getEntriesByName("ai-resume-to-paint") / ("ai-send-to-provisioning-ack").
// Every call is guarded: an environment without the User Timing API (jsdom) records nothing.
export function markStart(name: string): void {
  try {
    performance.clearMarks(name);
    performance.mark(name);
  } catch {
    // no User Timing API
  }
}

export function measureSince(startMark: string, measureName: string, afterPaint: boolean): void {
  const measure = () => {
    try {
      if (performance.getEntriesByName(startMark, "mark").length === 0) return;
      performance.measure(measureName, startMark);
      performance.clearMarks(startMark);
    } catch {
      // no User Timing API
    }
  };
  // requestAnimationFrame runs before the next paint; the timeout queued from it runs after that
  // frame has painted.
  if (afterPaint) requestAnimationFrame(() => setTimeout(measure, 0));
  else measure();
}
